<lib-icon [iconConfig]="downloadIcon" (onClicked)="onClick()"></lib-icon>
